// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
var PasswordSettings = require("../../../v5/settings/PasswordSettings.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MarkupHelpers = require("components/MarkupHelpers");

function PasswordPage(props) {
  return JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
              paddingFull: true,
              hasShadow: true,
              children: [
                JsxRuntime.jsx(PageUITitle.make, {
                      title: "Password"
                    }),
                JsxRuntime.jsx(PasswordSettings.make, {})
              ]
            });
}

var make = PasswordPage;

exports.make = make;
/* PageUITitle Not a pure module */
